
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { QuestionnaireQuestionModel } from './Entities.GormCrm.QuestionnaireQuestion';
import { Model, ModelProperty } from 'models/Model';


export class QuestionnaireModel extends Model<QuestionnaireModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'questionnaire.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'questionnaire.property.name' },
		{ name: 'created', type: 'Date', languageString: 'questionnaire.property.created', isHidden: true },
		{ name: 'tag', type: 'string', languageString: 'questionnaire.property.tag' },
		{ name: 'bindToTaskflow', type: 'boolean', languageString: 'questionnaire.property.bindToTaskflow' },
		{ name: 'questionnaireQuestions', type: 'QuestionnaireQuestionModel[]', languageString: 'questionnaire.property.questionnaireQuestions', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionModel }, properties: () => { return QuestionnaireQuestionModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public created?: Date;
	public tag: string;
	public bindToTaskflow: boolean;
	public questionnaireQuestions: QuestionnaireQuestionModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.created = undefined;
		this.tag = '';
		this.bindToTaskflow = false;
		this.questionnaireQuestions = [];
		
	}
	getProperties(){
		return QuestionnaireModel.classProperties;
	}
}

